import AppConsts from "./appconst";
import Util from "./util";
class SignalRAspNetCoreHelper {
  initSignalR() {
    var encryptedAuthToken = Util.abp.utils.getCookieValue(
      AppConsts.authorization.encrptedAuthTokenName
    );
    if (!encryptedAuthToken) {
      return;
    }

    Util.abp.signalr = {
      autoConnect: true,
      connect: undefined,
      hubs: undefined,
      qs:
        AppConsts.authorization.encrptedAuthTokenName +
        "=" +
        encodeURIComponent(encryptedAuthToken),
      url: AppConsts.remoteServiceBaseUrl + "signalr",
    };

    // abp.event.on("abp.signalr.connected", function() {
    //   console.log("hub connected SignalRAspNetCoreHelper");
    //   setInterval(() => {
    //     console.log("Hub state: " + Util.abp.signalr.hubs.common.state);
    //     if (Util.abp.signalr.hubs.common.state == 1) {
    //       console.log("Resend message SignalR");
    //       Util.abp.signalr.hubs.common.send("Ping");
    //     }
    //   }, 10000);
    // });

    abp.event.on("abp.signalr.connected", function() {
      console.log("hub connected");

      Util.abp.signalr.hubs.common.on("ImportProduct", function(notification) {
        console.log(notification);
      });

      Util.abp.signalr.hubs.common.on("Import.To", function(notification) {
        console.log(notification);
      });
    });

    Util.loadScript(AppConsts.appBaseUrl + "/dist/abp.signalr-client.js");
  }
}
export default new SignalRAspNetCoreHelper();
